<script setup>
import { isEmpty } from 'lodash'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useStore } from 'vuex'

import { ACTION_TYPES } from '@/utils/components-configurations/chekin-author-actions'
import { ASSIGNEE_ENTITY_KEYS } from '@/utils/entity-keys'
import { includesValue } from '@/utils/prop-validators'

import UserNameCell from '@/views/workspaces/settings/plugin-users/UserNameCell'

defineOptions({
  name: 'CheckinAuthorActions'
})

const props = defineProps({
  userData: {
    type: Object,
    default: () => ({})
  },

  avatarUrlKey: {
    type: String,
    default: ASSIGNEE_ENTITY_KEYS.AVATAR_URL
  },

  accountIdKey: {
    type: String,
    default: ASSIGNEE_ENTITY_KEYS.ACCOUNT_ID
  },

  userNameKey: {
    type: String,
    default: ASSIGNEE_ENTITY_KEYS.NAME
  },

  actionType: {
    type: String,
    required: true,
    validator: v => includesValue(v, ACTION_TYPES)
  }
})

const { t } = useI18n()

const action = computed(() => {
  if (props.actionType === ACTION_TYPES.CREATE) {
    return t('checkin.user_started_checkin').trim()
  }

  if (props.actionType === ACTION_TYPES.READ) {
    return t('checkin.user_made_checkin').trim()
  }

  return ''
})

const store = useStore()

const resolvedUserData = computed(() => {
  if (isEmpty(props.userData)) {
    return store.state.system.userData
  }

  return props.userData
})
</script>

<template>
  <div class="caa-Actions">
    <UserNameCell
      :account-id-key="accountIdKey"
      :avatar-url-key="avatarUrlKey"
      :item="resolvedUserData"
      :item-label="userNameKey"
    />
    <span v-if="action" class="oboard-truncated-text caa-ActionText">
      {{ action }}
    </span>
    <slot name="date" />
  </div>
</template>

<style lang="scss" scoped>
.caa-Actions {
  display: flex;
  align-items: center;
  gap: 6px;
  --unc-padding-right: 0;
  --unc-name-color: #{$primary-color-next};
  overflow: hidden;
  color: $dark-3;
  font-size: $fs-14;
  line-height: 20px;
}

.caa-ActionText {
  flex-shrink: 0;
  max-width: 70%;
}
</style>
